(() => {
  const SEL = {
    root: "[data-km-carousel]",
    track: "[data-km-carousel-track]",
    prev: "[data-km-carousel-prev]",
    next: "[data-km-carousel-next]",
  };

  const clamp = (n, a, b) => Math.max(a, Math.min(b, n));

  function hasOverflow(track){
    return track && (track.scrollWidth - track.clientWidth) > 2;
  }

  function refresh(root){
    const track = root.querySelector(SEL.track);
    const prev = root.querySelector(SEL.prev);
    const next = root.querySelector(SEL.next);
    if (!track || !prev || !next) return;

    const overflow = hasOverflow(track);

    if (!overflow){
      prev.disabled = true;
      next.disabled = true;
      return;
    }

    const max = track.scrollWidth - track.clientWidth;
    const x = track.scrollLeft;

    prev.disabled = x <= 2;
    next.disabled = x >= (max - 2);
  }

  function scrollByPage(track, dir){
    const step = clamp(track.clientWidth * 0.92, 240, 900);
    track.scrollBy({ left: step * dir, behavior: "smooth" });
  }

  function init(root){
    if (!root || root.__kmCarouselInit) return;
    root.__kmCarouselInit = true;

    const track = root.querySelector(SEL.track);
    const prev = root.querySelector(SEL.prev);
    const next = root.querySelector(SEL.next);
    if (!track || !prev || !next) return;

    prev.addEventListener("click", () => scrollByPage(track, -1));
    next.addEventListener("click", () => scrollByPage(track, 1));

    track.addEventListener("scroll", () => refresh(root), { passive: true });
    window.addEventListener("resize", () => refresh(root));

    // primeira medição depois do layout
    requestAnimationFrame(() => refresh(root));
    setTimeout(() => refresh(root), 250);
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(SEL.root).forEach(init);
  });

  document.addEventListener("shopify:section:load", (e) => {
    e.target.querySelectorAll(SEL.root).forEach(init);
  });
})();
